<template>
  <div class="text-center">
    <div class="styleMenuv" v-for="(option, index) in options" v-bind:key="index">
      <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn small link class="ma-2" dark v-bind="attrs" v-on="on" @click="redirect(option.href, option.items.length == 0)">
            <i v-if="option.icon" v-bind:class="option.icon"></i>
            {{ $tc(option.lang) }}
          </v-btn>
        </template>
        <v-list v-if="option.items.length > 0">
          <v-list-item
            v-for="(item, index) in option.items"
            v-bind:key="index"
            @click="redirect(item.href,true)"
          >
            <v-list-item-title>{{ $tc(item.lang) }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </div>
    
  </div>
</template>

<script>
export default {
 computed: {
    options: function () {
      const options = [
        {
          icon: "far fa-tachometer",
          lang: "top-menu.all.dashboard",
          name: null,
          href: "/admin/promoterDashboard",
          items: []
        },
        {
          icon: "far fa-pencil",
          lang: "top-menu.race.result-editor",
          href: `/admin/raceEdit?raceId=${this.$route.params.id}`,
          name: null,
          items: []
        },
        {
          icon: "far fa-clock",
          lang: "top-menu.race.scores",
          name: null,
          items: [
            {
              icon: "fas fa-flag-checkered",
              lang: "top-menu.race.results",
              href: `/promoter/#/events/races/raceDetails/results/${this.$route.params.id}`,
              name: 'ResultsOld'
            },
            {
              icon: "far fa-clock",
              lang: "top-menu.race.editor",
              href: `/promoter/#/events/races/raceDetails/edit-scores/${this.$route.params.id}`,
              name: 'ParticipantScoresOld'
            },
            {
              icon: "far fa-clock",
              lang: "top-menu.race.scoreAnalysis",
              href: `/promoter/#/events/races/raceDetails/raceAnalysis/${this.$route.params.id}`,
              name: 'ScoreAnalysis'
            }
          ],
        },        
        {
          icon: "far fa-arrow-left",
          lang: "top-menu.race.back-to-race-details",
          href: `/admin/raceDetails?raceId=${this.$route.params.id}`,
          name: null,
          items: []
        }        
      ];
      this.generateTopMenu(options);
      return options;
    },
    sectionsUpdated() {
      return this.$store.getters.getSectionsUpdate;
    },
    isChangesSections() {
      return (
        (this.$route.name == 'SectionEditor' || this.$route.name == 'SectionEditorOld') && 
        this.sectionsUpdated.length > 0
      );
    }
  },
  methods: {    
    generateTopMenu: function (items) {
      let options = [];
      options = items.map((elem) => {
        const subitems = elem.items.map((elem1) => {
          return {
            ...elem1,
            text: this.$t(elem1.lang)
          };
        });
        return {
          ...elem,
          text: this.$t(elem.lang),
          items: subitems
        };
      });
      this.$emit("loadTopMenuResponsive", options);
    }, 
    isUrlVue(url) {
      return url.includes('/promoter/#/');
    },
    redirect(url, band) {
      if(this.isChangesSections && !this.isUrlVue(url)) {
        this.$store.commit('setNextUrl',url);
        this.$store.commit('setActiveMessageConfirmation', true);
      } else if(band) {
        window.location.href = url;
      }
    }
  },
};
</script>
<style>
.legacy-dashboard {
  text-align: right !important;
  text-align: -moz-right !important;
  text-decoration: underline !important;
  color: #0e152d !important;
  margin-right: 10px;
}
.styleMenuv {
  display: inline;
}
</style>
